import { render, staticRenderFns } from "./MobileMoney.vue?vue&type=template&id=0e8c10cb&scoped=true&"
import script from "./MobileMoney.vue?vue&type=script&lang=js&"
export * from "./MobileMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8c10cb",
  null
  
)

export default component.exports